export const defaultSettings = {
    beta: false,
    comment_sort: "top",
    custom_styling: true,
    expand: "card",
    expand_thread: true,
    hide_upvoted: false,
    index_profile: false,
    infinite_scroll: true,
    moderates: [],
    new_tab: false,
    notify_comments: true,
    scroll_top: true,
    show_nsfw: true,
    subscribed: [],
    theme: "light",
    topic_nsfw: false,
    topic_other: true,
    topic_politics: false,
    username: "",
    active_feed: 1,
    trending_topics: ['Politics', 'NSFW'],
    blocked_communities: [],
    pro_tier: 0,
    pro_expire: 0
};

export const themeOptions = [
    {value: 'light', label: `Light`},
    {value: 'dark', label: `Dark`},
];